// Small DOM HUD showing the configured broadcast delay (GDD §9.4 UX requirement).
// Rendered bottom-right of the canvas mount.

export interface DelayIndicatorHandle {
  el: HTMLDivElement;
  setDelay: (seconds: number) => void;
  dispose: () => void;
}

export function createDelayIndicator(mount: HTMLElement): DelayIndicatorHandle {
  const el = document.createElement('div');
  el.setAttribute('data-scene', 'delay-indicator');
  el.style.position = 'absolute';
  el.style.right = '14px';
  el.style.bottom = '14px';
  el.style.zIndex = '900';
  el.style.padding = '6px 12px';
  el.style.borderRadius = '8px';
  el.style.background = 'rgba(6, 12, 50, 0.7)';
  el.style.color = '#FFC43D';
  el.style.fontFamily = `'Inter', system-ui, sans-serif`;
  el.style.fontSize = '0.9rem';
  el.style.letterSpacing = '0.04em';
  el.textContent = 'delay —';
  mount.appendChild(el);

  function setDelay(seconds: number): void {
    el.textContent = `delay ${seconds.toFixed(1)}s`;
  }

  return {
    el,
    setDelay,
    dispose() {
      el.remove();
    },
  };
}
